import createIcon from '../../createIcon';

/**
 * @component @name Reorder
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMyAxNUgyMVYxM0gzVjE1Wk0zIDE5SDIxVjE3SDNWMTlaTTMgMTFIMjFWOUgzVjExWk0zIDVWN0gyMVY1SDNaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Reorder = createIcon('Reorder', [
  [
    'path',
    { d: 'M3 15H21V13H3V15ZM3 19H21V17H3V19ZM3 11H21V9H3V11ZM3 5V7H21V5H3Z', key: 'lpr87i' },
  ],
]);

export default Reorder;
